import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { Title, useCommonStyles } from '../../utils';
import ViewPoDocument from './ViewPoDocument';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import Assets from '../../Component/Common/Assets';
import AddUpdateDocuments from './AddUpdateDocuments';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import FilterListIcon from '@mui/icons-material/FilterList';
import NoDataFound from '../../Component/Common/NoDataFound';
import { standardDateFormat } from '../../lib/standardDateFormat';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonPagination from '../../Component/Common/CommonPagination';
import { deletePODocument, getPODocumentById, getPODocuments } from '../../Redux/Actions/PurchaseOrder';
import { Badge, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import { useConfirm } from 'material-ui-confirm';
import { useAppSelector } from '../../Redux/app/hooks';
import CommonSearchField from '../../Component/Common/CommonSearchField';
import CustomDrawer from '../../Component/Common/CustomDrawer';

const PurchaseOrderDocuments = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [selectedItem, setSelectedItem] = useState({});
    const [listData, setListData] = useState({});
    const [isOpenAddUpdateDocuments, setIsOpenAddUpdateDocuments] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isViewPoDocument, setIsViewPoDocument] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const [data, setData] = useState({})

    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);
    const initialFilterState = {
        rawMaterial: [],
    };

    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);
    const filterDataCount = (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial?.length : 0)

    // =============== Handler ===============
    let PerPage = 10
    const tabelHeader = ["SR.", "PO NUMBER", "VENDOR NAME", "DATE", "Category", "Documents", "Action"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    const handleChangePage = (e, p) => {
        setPage(p);
    };

    // ============= get Inventories API =============
    const _getPODocuments = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "category": isApllyFilter ? (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial : null) : null,
        }
        response = await dispatch(getPODocuments(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };


    // ============= Get By Id Inventory Field API =============
    const _getPODocumentById = async (id, isView) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getPODocumentById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response
                setSelectedItem(response?.payload?.data?.response)
                setData({
                    ...data,
                    "basicDetails": {
                        "poNumber": { poNumber: res?.basicDetails?.poNumber },
                        "poDate": res?.basicDetails?.poDate,
                        "vendor": { name: res?.basicDetails?.vendorName },
                        "category": { name: res?.basicDetails?.category },
                        "hazira": res?.basicDetails?.hazira,
                        "shippingLine": res?.basicDetails?.shippingLine,
                        "paymentStatus": { name: res?.basicDetails?.paymentStatus },
                        "advanceLicenseNumber": res?.basicDetails?.advanceLicenseNumber ?? null,
                        "quantity": res?.basicDetails?.importQty,
                        "cifValue": res?.basicDetails?.cifValue,
                    },
                    "piDetails": res?.piDetails,
                    "blDetails": res?.blDetails,
                    "documentSetDetails": {
                        "documentSet": { name: res?.documentSetDetails?.documentSet },
                        "documentSetDocument": res?.documentSetDetails?.documentSet?.documentSetDocument
                    },
                    "boeDetails": {
                        "boeDate": res?.boeDetails?.boeDate,
                        "boeNumber": res?.boeDetails?.boeNumber,
                        "boeDocument": res?.boeDetails?.boeDocument
                    },
                    "swiftCopyDetails": res?.swiftCopyDetails,
                    "debitAdviceDetails": res?.debitAdviceDetails,
                    "ewayDetails": res?.ewayDetails,
                    "invoiceDetails": res?.invoiceDetails,
                    "packingListDetails": res?.packingListDetails,
                    "pimsDetails": res?.pimsDetails,
                    "advanceLicensesNumber": res?.advanceLicensesNumber ?? null
                })
                if (isView) {
                    setIsViewPoDocument(true)
                } else {
                    setIsEditMode(true)
                    setIsOpenAddUpdateDocuments(true)
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Delete Inventory Field API =============
    const _deletePODocument = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(deletePODocument(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSnackBar("success", response?.payload?.message)
                _getPODocuments();
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getPODocuments();
        } else {
            _getPODocuments();
        }
    }, [page, searchValue])

    useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        setPage(1)
        _getPODocuments(1);
    }, [isApllyFilter])

    return (
        <>
            {isOpenAddUpdateDocuments ?
                <AddUpdateDocuments setSearchValue={setSearchValue} isEditMode={isEditMode} setIsEditMode={setIsEditMode} setIsOpenAddUpdateDocuments={setIsOpenAddUpdateDocuments} setData={setData} data={data} selectedItem={selectedItem} setSelectedItem={setSelectedItem} _getPODocuments={_getPODocuments} />
                :
                isViewPoDocument ?
                    <ViewPoDocument setSearchValue={setSearchValue} setIsViewPoDocument={setIsViewPoDocument} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setData={setData} />
                    :
                    <Grid container spacing={2} padding={"25px"}>
                        <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Documents List</Typography>
                            <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                                <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["PO NUMBER", "VENDOR NAME", "Category"]} />
                                <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                                    <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => { setIsOpenFilterDrawer(true) }}>Filters </Button>
                                </Badge>
                                {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                    <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddUpdateDocuments(true)}>Add Documents</Button>
                                }
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                        <TableHead>
                                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                {tabelHeader?.map((ele) => {
                                                    return (
                                                        <StyledTableCell>{ele}</StyledTableCell>
                                                    )
                                                })}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {listData?.response?.length > 0 ?
                                                listData?.response?.map((row, index) => {
                                                    const totalDocuments = (row?.blDetails?.blDocument?.length || 0) + (row?.boeDetails?.boeDocument?.length || 0) + (row?.debitAdviceDetails?.debitAdviceDocument?.length || 0) + (row?.documentSetDetails?.documentSetDocument?.length || 0) + (row?.ewayDetails?.ewayDocument?.length || 0) + (row?.invoiceDetails?.invoiceDocument?.length || 0) + (row?.packingListDetails?.packingListDocument?.length || 0) + (row?.piDetails?.piDocument?.length || 0) + (row?.pimsDetails?.pimsDocument?.length || 0) + (row?.swiftCopyDetails?.swiftCopyDocument?.length || 0);
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <StyledTableRow>
                                                                <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                                <StyledTableCell> {row?.basicDetails?.poNumber ? row?.basicDetails?.poNumber : "NA"}</StyledTableCell>
                                                                <StyledTableCell> {row?.basicDetails?.vendorName ? row.basicDetails?.vendorName : "NA"}</StyledTableCell>
                                                                <StyledTableCell> {row?.createdAt && standardDateFormat(row?.createdAt)}</StyledTableCell>
                                                                <StyledTableCell> {row?.basicDetails?.category ? row.basicDetails?.category : "NA"}</StyledTableCell>
                                                                <StyledTableCell>
                                                                    <Box display={"flex"} gap={2}>
                                                                        <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                            <Assets absolutePath={true} src={`/assets/img/Pdf.svg`} />
                                                                            {"Documents"}
                                                                        </Box>
                                                                        <Box onClick={() => _getPODocumentById(row?._id, true)} sx={{ cursor: "pointer", border: `1px solid ${theme.palette.primary.main}`, backgroundColor: theme.palette.lightPrimary.main, borderRadius: "8px", padding: "6px 10px", display: "flex", alignItems: "center", gap: "2px" }}>
                                                                            <Typography fontSize={"12px"} color={"primary"} fontFamily={"Satoshi-Bold"}>{totalDocuments || 0} </Typography>
                                                                            <AddIcon sx={{ fontSize: "14px", color: theme.palette.primary.main }} />
                                                                        </Box>
                                                                    </Box>
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    <Box display={"flex"} gap={1}>
                                                                        {getPermissionList?.viewPermission?.includes('Purchase Order') &&
                                                                            <IconBackground icon={"visibility"} onClick={() => _getPODocumentById(row?._id, true)} />
                                                                        }
                                                                        {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                                                            <IconBackground icon={"edit"} onClick={() => _getPODocumentById(row?._id, false)} />
                                                                        }
                                                                        {getPermissionList?.editPermission?.includes('Purchase Order') &&
                                                                            <IconBackground icon={"delete"}
                                                                                onClick={(e) => {
                                                                                    confirmDialogue({
                                                                                        title: `Are you sure you want to delete?`,
                                                                                    }).then(() => {
                                                                                        _deletePODocument(row?._id)
                                                                                    }).catch((err) => { console.error(err) });
                                                                                }}
                                                                            />
                                                                        }
                                                                    </Box>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <CommonPagination
                                    totalCount={listData?.count}
                                    count={Math.ceil(listData?.count / PerPage)}
                                    itemsPerPage={PerPage}
                                    page={page}
                                    onChange={handleChangePage}
                                />
                            </Box>
                        </Grid>
                    </Grid>
            }
            <CustomDrawer
                isOnlyIconClose
                isDrawerOpen={isOpenFilterDrawer}
                handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}
                title="Filter"
            >
                <Grid container p={2}>
                    <Grid item xs={12}>
                        <Title>Category</Title>
                    </Grid>
                    {["Base Paper", "Film", "Chemical", "Ink", "Packaging Material", "Other"].map((ele) => {
                        const isChecked = filterData.rawMaterial.includes(ele);
                        return (
                            <Grid item xs={12} sm={6} md={4} key={ele}>
                                <FormControl component="fieldset">
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isChecked}
                                                    onChange={(e) => {
                                                        setFilterData((prev) => ({
                                                            ...prev,
                                                            rawMaterial: e.target.checked
                                                                ? [...prev.rawMaterial, ele]
                                                                : prev.rawMaterial.filter((item) => item !== ele)
                                                        }));
                                                    }}
                                                />
                                            }
                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                            label={ele}
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                        );
                    })}
                    <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                        <Button className={classes.cancelButton}
                            onClick={() => {
                                setFilterData(initialFilterState);
                                // setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) 
                            }
                            }>
                            Reset Filter
                        </Button>
                        <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                            Apply Filter
                        </Button>
                    </Grid>
                </Grid>
            </CustomDrawer>
        </>
    )
}

export default PurchaseOrderDocuments